<template>
  <div class="index">
    <navtab class="navTab" v-on:select="select"></navtab>
    <!-- 登录 -->
    <div class="loginPart" v-if="isSelect==1" v-show="!isEndLogin">
      <div class="onlyLef">
        <div class="loginHead">
          <img src="../assets/loginLogo.png" alt />
        </div>
        <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div>
      </div>
      <div class="onlyRig">
        <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
        <ul class="loginNav">
          <li @click="notRegister()" :class="currentNum==1?'style':''">登录</li>
          <li @click="isRegister()" :class="currentNum==2?'style':''">注册</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="loginAdmin" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="loginPassword" />
          </li>
        </ul>
        <div class="newDiv">
          <div class="newDivLeft" @click="rememberPw">
            <input class="radioInput" :checked="chooseAll" type="checkbox" />
            <p>记住密码</p>
          </div>
          <span class="forgetPassword" @click="forgetPasswordEvent()">忘记密码？</span>
        </div>
        <div class="loginBtn" @click="loginEvent()">登 录</div>
        <p class="newP" @click="nowToRegister()">
          <span>还未注册，现在就</span>
          <span id="newSpan">注册</span>
        </p>
      </div>
    </div>
    <!-- 注册 -->
    <div class="loginPart" v-if="isSelect==2" v-show="!isEndLogin">
      <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
      <div class="onlyLef">
        <div class="loginHead" v-show="!isforget">
          <el-upload
            class="avatar-uploader"
            action="http://192.168.1.240:8080/huban-dcfadmin/file/upload"  
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon addHeadImg"></i> -->
            <img :src="imageUrl?imageUrl:newImageUrl" class="avatar" />
          </el-upload>
        </div>
        <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div>
      </div>
      <div class="onlyRig">
        <ul class="loginNav">
          <li @click="notRegister()" :class="currentNum==1?'style':''">登录</li>
          <li @click="isRegister()" :class="currentNum==2?'style':''">注册</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="registerAdmin" />
          </li>
          <li>
            <input type="text" placeholder="请输入验证码" v-model="checkNum" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="registerPassword" />
          </li>
          <li>
            <input type="password" placeholder="请确认密码" v-model="aginPassword" />
          </li>
          <li id="getKey" @click="getKey(registerType,registerAdmin)">获取验证码</li>
        </ul>
        <div class="loginBtn" v-show="!isforget" @click="register()">注 册</div>
        <div class="loginBtn" v-show="isforget">完 成</div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="loginPart" v-if="isSelect==3" v-show="!isEndLogin">
      <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
      <div class="onlyLef">
        <div class="loginHead">
          <img src="../assets/index.png" alt />
        </div>
        <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div>
      </div>
      <div class="onlyRig">
        <ul class="loginNav">
          <li>忘记密码</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="forgetAdmin" />
          </li>
          <li>
            <input type="text" placeholder="请输入验证码" v-model="checkNum" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="forgetPassword" />
          </li>
          <li>
            <input type="password" placeholder="请确认密码" v-model="forgetAginPassword" />
          </li>
          <li id="getKey" @click="getKey(forgetType,forgetAdmin)">获取验证码</li>
        </ul>
        <div class="loginBtn" @click="forget()">完 成</div>
      </div>
    </div>
    <div class="top" v-show="isEndLogin">
      <!-- <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item,index) in bannerList" :key="index">
          <img :src="item.imgurl" alt />
        </el-carousel-item>
      </el-carousel>-->

      <template>
        <el-carousel type="card" :interval="4300" :height="heightSc+'px'" class="lunboDiv">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <!-- <h3>{{ item }}</h3> -->
            <img :src="item.imgurl" alt />
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <span class="title" v-show="isEndLogin">浙江桃园科技有限公司简介</span>
    <div
      class="componayIntro"
      v-show="isEndLogin"
      v-if="richHtml==''||richHtml==null"
      ref="richHtml"
    >浙江桃园智能科技有限公司办公室地址位于浙江省大城市，人间天堂杭州，杭州 杭州市西湖区天目山路217号18层1801-1室，于2016年03月15日在杭州市高新区（滨江）市场监督管理局注册成立，注册资本为10000000（万元），在公司发展壮大的3年里，我们始终为客户提供好的产品和技术支持、健全的售后服务，我公司主要经营技术开发、技术服务、技术咨询、成果转让：机械设备、电子产品、新型材料、计算机软硬件、通信技术、计算机网络技术；销售：仪器仪表、计算机软硬件、电子产品、机械设备。，我们有好的产品和专业的销售和技术团队，我公司属于杭州旧黄页分类黄页行业，如果您对我公司的产品服务有兴趣，期待您在线留言或者来电咨询</div>
    <div
      class="componayIntro"
      v-show="isEndLogin"
      v-else
      v-html="richHtml"
      ref="richHtml"
    >浙江桃园智能科技有限公司办公室地址位于浙江省大城市，人间天堂杭州，杭州 杭州市西湖区天目山路217号18层1801-1室，于2016年03月15日在杭州市高新区（滨江）市场监督管理局注册成立，注册资本为10000000（万元），在公司发展壮大的3年里，我们始终为客户提供好的产品和技术支持、健全的售后服务，我公司主要经营技术开发、技术服务、技术咨询、成果转让：机械设备、电子产品、新型材料、计算机软硬件、通信技术、计算机网络技术；销售：仪器仪表、计算机软硬件、电子产品、机械设备。，我们有好的产品和专业的销售和技术团队，我公司属于杭州旧黄页分类黄页行业，如果您对我公司的产品服务有兴趣，期待您在线留言或者来电咨询</div>
    <!-- <p class="title" v-show="isEndLogin">联系我们</p> -->
    <div class="aboutUs" v-show="isEndLogin">
      <!-- <div id="newMapDiv">
        <div ref="allmap" class="aboutUsLeft"></div>
      </div>-->
      <div ref="allmap" class="aboutUsLeft"></div>
    </div>
    <ul class="aboutUsRight" v-show="isEndLogin">
      <Li>公司地址：浙江德清塔山街901号 地理信息产业园 A6幢</Li>
    </ul>
  </div>
</template>
<script>
import navtab from "./navtab";
export default {
  name: "index",
  components: {
    navtab: navtab
  },
  inject: ["reload"],
  data() {
    return {
      richHtml:"",
      heightSc: "",
      htmlWord:
        "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      chooseAll: true, //true记住密码
      isSelect: 1,
      loginAdmin: "",
      loginPassword: "",
      registerAdmin: "",
      checkNum: "",
      registerPassword: "",
      aginPassword: "",
      isforget: false,
      imageUrl: "",
      address: "浙江德清塔山街901号 地理信息产业园 A6幢",
      isEndLogin: true,
      isShow: true,
      phoneNum: "",
      registerType: 1,
      forgetType: 2,
      user: "",
      forgetAdmin: "",
      forgetPassword: "",
      forgetAginPassword: "",
      currentNum: 1,
      bannerList: [],
      newImageUrl: require("../assets/head.jpg")
    };
  },
  // 账号：18757738918 密码：123456
  methods: {
    getrichWord(){
      this.$axios
        .get(this.$http + "api/personal/pcaboutus")
        .then(res => {
          //console.log(res);
          if (res.data.code == 0) {
            //console.log(res);
            this.richHtml=res.data.Entity.content;
             this.exampleSolve(this.$refs.richHtml);
          }
        })
        .catch(err => {});
    },
     // 获取目标元素，返回数组
    exampleSolve(domele) {
      let refEle = domele;
      //console.log(domele);
      this.$nextTick(() => {
        let imgArr = refEle.getElementsByTagName("img");
        //console.log(imgArr);
        this.handleStyle(imgArr);
        let videoArr = refEle.getElementsByTagName("video");
        this.handleStyle(videoArr);
        //console.log(videoArr);
      });
    },
    // 处理富文本中的img 和 video标签元素
    handleStyle(ele) {
      let elem = ele;
      let maxWidth = $(".componayIntro").width();
      let ratio = 0;
      for (let i = 0; i < elem.length; i++) {
        //console.log($(elem[i]).width(), maxWidth);
        if ($(elem[i]).width() > maxWidth) {
          //console.log(elem[i]);
          ratio = $(elem[i]).width() / maxWidth;
          var height = $(elem[i]).height() / ratio;
          //console.log($(elem[i]).height(), ratio);
          $(elem[i]).css({
            width: maxWidth + "px",
            height: height + "px",
            margin: "0 auto",
            display: "block"
          });
          //console.log($(elem[i]).width());
        } else if ($(elem[i]).width() < maxWidth) {
          ratio = $(elem[i]).width() / maxWidth;
          var height = $(elem[i]).height() / ratio;
          $(elem[i]).css({
            width: maxWidth + "px",
            height: height + "px",
            margin: "0 auto",
            display: "block"
          });
        }
      }
    },
    rememberPw() {
      this.chooseAll = !this.chooseAll;
      if (this.chooseAll) {
        // alert("记住密码");
      }
    },
    // 返回首页
    backToIndex() {
      let flag = 1;
      sessionStorage.setItem("flag", JSON.stringify(flag));
      this.isEndLogin = true;
      document
        .getElementsByClassName("index")[0]
        .classList.remove("myNewstyle");
    },
    // /api/Home/banner获取首页广告
    getBanner() {
      this.$axios
        .get(this.$http + "api/Home/banner")
        .then(res => {
          //console.log(res);
          if (res.data.code == 0) {
            this.bannerList = res.data.Entity;
            //console.log(this.bannerList);
          }
        })
        .catch(err => {});
    },
    select(selectFlag) {
      //console.log("111");
      document.getElementsByClassName("index")[0].classList.add("myNewstyle");
      this.isSelect = selectFlag;
      this.isEndLogin = false;
      if (this.isSelect == 1) {
        this.currentNum = 1;
      } else {
        this.currentNum = 2;
      }
    },
    // 获取验证码  /api/login/code/{userName}/{type} type=1为注册 2为忘记密码
    getKey(type, registerAdmin) {
      //console.log(type);
      //console.log(registerAdmin);
      // 验证手机号  0?(13|14|15|17|18)[0-9]{9}
      // let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      // //console.log(myreg.test(registerAdmin));
      // if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(registerAdmin))) {
      //   alert("手机号格式错误");
      //   return false;
      // } else {
      this.$axios
        .get(this.$http + "api/login/code/" + registerAdmin + "/" + type)
        .then(res => {
          //console.log(res);
          if (res.data.code == 500) {
            // alert(res.data.msg);
            this.$notify({
              title: "提示信息",
              message: res.data.msg,
              type: "warning"
            });
          } else if (res.data.code == 0) {
            // alert(res.data.msg);
            this.$notify({
              title: "成功",
              message: res.data.msg,
              type: "success"
            });
          } else {
            // alert(res.data.msg);
            this.$notify.error({
              title: "错误",
              message: res.data.msg
            });
          }
        })
        .catch(err => {});
      // }
    },
    // 注册 /api/login/save
    register() {
      //console.log("444");
      if (this.registerPassword == this.aginPassword) {
        //console.log(this.checkNum, this.registerPassword, this.registerAdmin);
        let obj = {
          code: this.checkNum,
          passWord: this.registerPassword,
          userName: this.registerAdmin
        };
        let data = JSON.stringify(obj);
        this.$axios({
          method: "post",
          url: this.$http + "api/login/save",
          headers: {
            "Content-Type": "application/json"
          },
          data: data
        })
          .then(res => {
            //console.log(res);
            if (res.data.code == 0) {
              // alert("注册成功");
              this.$notify({
                title: "成功",
                message: "注册成功",
                type: "success"
              });
              this.loginPassword = this.registerPassword;
              this.loginAdmin = this.registerAdmin;
              this.loginEvent();
              // this.isEndLogin = true;
            } else {
              // alert(res.data.msg);
              this.$notify({
                title: "失败",
                message: res.data.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {});
      } else {
        // alert("密码不一致，请重新输入！");
        this.$notify.error({
          title: "错误",
          message: "密码不一致，请重新输入！"
        });
      }
    },
    // /api/login/wantUpd忘记密码
    forget() {
      //console.log("444");
      if (this.forgetPassword == this.forgetAginPassword) {
        let obj = {
          code: this.checkNum,
          passWord: this.forgetPassword,
          userName: this.forgetAdmin
        };
        let data = JSON.stringify(obj);
        this.$axios({
          method: "post",
          url: this.$http + "api/login/wantUpd",
          headers: {
            "Content-Type": "application/json"
          },
          data: data
        })
          .then(res => {
            if (res.data.code == 0) {
              // alert("修改成功");
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success"
              });
              this.isSelect = 1;
            } else {
              // alert(res.data.msg);
              this.$notify({
                title: "失败",
                message: res.data.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {});
      } else {
        // alert("密码不一致，请重新输入！");
        this.$notify.error({
          title: "错误",
          message: "密码不一致，请重新输入！"
        });
      }
    },
    // 登陆/api/login/login登陆  传入账号userName密码passWord
    loginEvent() {
      let obj = {
        passWord: this.loginPassword,
        userName: this.loginAdmin
      };
      //console.log(obj);
      let data = JSON.stringify(obj);
      this.$axios({
        method: "post",
        url: this.$http + "api/login/login",
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      })
        .then(res => {
          if (res.data.code == 0) {
            if (this.chooseAll) {
              // alert("记住密码");
              localStorage.setItem("userZhPw", JSON.stringify(obj));
              //console.log("这是记住的密码" + localStorage.getItem("userZhPw"));
            } else {
              localStorage.setItem("userZhPw", "");
            }
            //console.log(res);
            this.user = res.data.user;
            sessionStorage.setItem("user", JSON.stringify(this.user));
            // //console.log("登陆成功");
            this.$notify({
              title: "成功",
              message: "登陆成功",
              type: "success"
            });
            // this.$router.back(-1);
            let flag = 1;
            sessionStorage.setItem("flag", JSON.stringify(flag));
            sessionStorage.setItem("userName", JSON.stringify(res.data.user));
            this.reload();
            // this.isLogin = false;
            // this.isEndLogin = true;
            this.isEndLogin = true;
            document
              .getElementsByClassName("index")[0]
              .classList.remove("myNewstyle");
          } else {
            // //console.log("登陆失败");
            // alert(res.data.msg);
            this.$notify({
              title: "失败",
              message: res.data.msg,
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    // 选择头像
    beforeAvatarUpload(file) {
      //console.log("选择头像");
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传头像成功回调
    handleAvatarSuccess(res, file) {
      //console.log(res, file);
      if (res.code == 0) {
        this.imageUrl = URL.createObjectURL(file.raw);
        // alert("上传成功");
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success"
        });
      }
    },
    // 取消登陆
    cancelLogin() {
      // this.isLogin = false;
      this.isEndLogin = true;
      document
        .getElementsByClassName("index")[0]
        .classList.remove("myNewstyle");
    },
    // 选择登陆模块
    notRegister() {
      this.isSelect = 1;
      this.currentNum = 1;
    },
    // 选择注册模块
    isRegister() {
      this.isSelect = 2;
      this.currentNum = 2;
    },
    nowToRegister() {
      this.isSelect = 2;
      this.currentNum = 2;
    },
    // 忘记密码
    forgetPasswordEvent() {
      this.isSelect = 3;
    },
    // 百度地图
    map() {
      let map = new window.BMap.Map(this.$refs.allmap); // 创建Map实例
      map.centerAndZoom(new window.BMap.Point(116.404, 39.915), 12); // 初始化地图,设置中心点坐标和地图级别
      map.addControl(
        new window.BMap.MapTypeControl({
          //添加地图类型控件
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
          anchor: BMAP_ANCHOR_TOP_LEFT
        })
      );
      map.enableScrollWheelZoom(false); //开启鼠标滚轮缩放
      // 创建地址解析器实例
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上，并调整地图视野
      myGeo.getPoint(this.address, point => {
        if (point) {
          map.centerAndZoom(point, 11);
          map.addOverlay(new BMap.Marker(point));
          var infoWindow = new BMap.InfoWindow(this.address); // 创建信息窗口对象
          map.openInfoWindow(infoWindow, point); //开启信息窗口
        }
      });
    }

    // test() {
    //   this.$axios({
    //     method: "post",
    //     url: "/user",
    //     data: {
    //       name: "wise",
    //       info: "wrong"
    //     }
    //   });
    // }
  },
  created() {
    //console.log(this.currentNum);
  },
  mounted() {
    this.getrichWord();
    // 轮播图的顶级父盒子宽度为屏幕的90%，中间图片宽度为 imgwidth=document.body.clientWidth*0.9*0.8
    // 那么高度就应该计算为 imgHeight=（imgwidth*移动端图片的实际高度）/ 移动端图片的实际宽度
    //console.log(document.body.clientWidth);
    // this.heightSc=(document.body.clientWidth*0.9*200)/355;
    this.heightSc = (document.body.clientWidth * 0.9 * 0.8 * 225) / 436;
    this.getBanner();
    this.map();
    //console.log(localStorage.getItem("user"));
    //console.log(sessionStorage.getItem("flag"));
    //console.log(sessionStorage.getItem("flag") == "null");
    if (sessionStorage.getItem("flag") == "null") {
      //console.log("111");
      this.isLogin = 1;
      this.isEndLogin = false;
      document.getElementsByClassName("index")[0].classList.add("myNewstyle");
    }
    // if (
    //   JSON.parse(sessionStorage.getItem("flag"))!=1
    // ) {
    //   //console.log('999');
    //   this.isLogin = 1;
    //   this.isEndLogin = false;
    //   document.getElementsByClassName("index")[0].classList.add("myNewstyle");
    // } else {
    //   this.isEndLogin = true;
    //   document
    //     .getElementsByClassName("index")[0]
    //     .classList.remove("myNewstyle");
    // }
    if (localStorage.getItem("userZhPw")) {
      this.loginAdmin = JSON.parse(localStorage.getItem("userZhPw")).userName;
      this.loginPassword = JSON.parse(
        localStorage.getItem("userZhPw")
      ).passWord;
      // //console.log(
      //   "这是上次登录记住的密码" + this.loginAdmin,
      //   this.loginPassword
      // );
    }

    //  passWord: this.loginPassword,
    //     userName: this.loginAdmin
    // let user = sessionStorage.getItem("user");

    // //console.log(JSON.parse(sessionStorage.getItem("flag")));
    // let flag = JSON.parse(sessionStorage.getItem("flag"));
    // if (flag == 1) {
    //   this.isLogin = false;
    //   this.isEndLogin = true;
    //   this.iscancel = false;
    //   // document.getElementsByClassName("index")[0].classList.remove("myNewstyle");
    // }
    //   登陆成功后再保存
    // let obj = {
    //   loginAdmin: this.loginAdmin,
    //   loginPassword: this.loginPassword
    // };
    // localStorage.setItem("PerInfo", obj);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.index .addressaaa {
  background-color: #fff;
}
/* <div class="backIndexDiv">
          <img src="../assets/indexback.png" alt="">
          <p>返回首页</p>
        </div> */
.index .backIndexDiv {
  position: absolute;
  left: 30px;
  bottom: -36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;
}
.index .backIndexDiv img {
  display: block;
  height: 23px;
  width: 23px;
}
.index .backIndexDiv p {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: #158DD3;
  margin-left: 10px;
}
/* <p class="newP"><span>还未注册，现在就</span><span id="newSpan">注册</span></p> */
.index .newP {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #827e7e;
  margin-bottom: 30px;
  font-family: MicrosoftYaHei;
  cursor: pointer;
}
.index #newSpan {
  color: #158DD3;
}
.index .index {
  background-color: #fff;
}
.index .el-carousel__indicators--outside {
  opacity: 0;
}
/* .el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
} */
.index .el-carousel__container {
  position: relative;
  height: 528px;
  /* width: 80%;
  margin: 0 auto; */
  /* box-shadow: 3px 2px 4px 5px #ccc; */
}
.index .top {
  width: 90%;
  height: 42%;
  position: relative;
  margin: 0 auto;
  margin-top: 30px;
}
.index .top img {
  display: block;
  margin: 0 auto;
  /* max-height: 100%; */
  /* max-width: 100%; */
  /* min-width: 80%; */
  /* min-height: 100%; */
  box-shadow: 0px 10px 10px 0px rgba(102, 102, 102, 0.2);
  width: 80%;
  height: 100%;
}
.index .avatar-uploader,
.index .el-upload {
  width: 100% !important;
  height: 100% !important;
}

.index #getKey {
  width: 40%;
  background-color: #158DD3;
  margin: 0 auto;
  height: 33px;
  line-height: 33px;
  cursor: pointer;
  /* border-radius: 3px; */
  color: #ffffff;
  border: 0;
  font-size: 14px;
  /* text-decoration: underline; */
  border-bottom: 1px solid #b5b4b4;
}
/* #getKey:hover {
  text-decoration: underline;
  border-radius: 0;
  border-bottom: 1px solid #e14651;
  color: #e14651;
} */
.index .addHeadImg {
  color: #158DD3;
  font-size: 211px;
  border: 3px solid #158DD3;
  border-radius: 50%;
}
 .myNewstyle {
  /* background-image: url("../assets/bg.png"); */
  /* background: rgba(231, 240, 255, 1); */
  background-color: rgba(231, 240, 255, 1) !important;
}
.index {
  min-height: 100vh;
  /* background-image: url("../assets/bg.png"); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.index .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
.index .loginPart {
  /* width: 830px; */
  width: 900px;
  /* height: 38%; */
  /* background: #fff; */
  background-image: url("../assets/loginbj.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 30px;
  /* margin: 0 auto;
  margin-top: 5%; */
  /* margin: 0 auto; */
  position: absolute;
  /* top: 10%;
  left: 50%;
  transform: translateX(-50%) scale(0.8); */
  top: 23%;
  left: 50%;
  transform: translate(-50%, 0%) scale(0.7);
  z-index: 10;
  padding: 0 0;
  padding-bottom: 4%;
  /* position: relative; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 10px;
}
.index #close {
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 18px;
  color: #b5b4b4;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  /* background-color: pink; */
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #ccc;
  overflow: hidden;
}
.index .loginPart .loginHead {
  height: 360px;
  width: 360px;
  overflow: hidden;
  border-radius: 50%;
  margin: 20px auto;
  /* border: 1px solid #b5b4b4; */
  /* margin-bottom: 20px; */
  text-align: center;
  /* line-height: 50px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index .loginPart .loginHead img {
  display: block;
  width: 100%;
  height: 100%;
}
.index .loginPart .loginNav {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.index .loginPart .loginNav li {
  height: 86%;
  cursor: pointer;
  text-align: center;
  /* width: 52px; */
  /* width: 100%; */
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  margin: 0 10%;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.index .loginPart .loginNav li:hover {
  /* color: #158DD3; */
  border-bottom: 2px solid #158DD3;
  /* text-decoration: underline; */
}
.index .style {
  color: #158DD3;
  border-bottom: 2px solid #158DD3;
  /* text-decoration: underline; */
}
.index .loginPart .loginInput {
  width: 90%;
  margin: 0 auto;
}
.index .loginPart .loginInput li {
  height: 48px;
  /* background: black; */
  margin: 12% 0;
  border: 1px solid #b5b4b4;
  border-radius: 24px;
  padding: 0 22px;
}
.index .loginPart .loginInput li input {
  padding-left: 3px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 0;
  color: rgb(32, 32, 32);
  outline: none;
  font-size: 14px;
  /* 控制文字之间的间距 */
  letter-spacing: 1px;
}
.index input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #b5b4b4;
}

.index input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #b5b4b4;
}

.index input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #b5b4b4;
}

.index input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #b5b4b4;
}

.index .loginPart .newDiv {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* background-color: purple; */
}
.index .loginPart .newDiv .newDivLeft {
  /* display: flex;
  flex-direction: row;
  justify-content: flex-start; */
  font-size: 14px;
  width: 150px;
  position: relative;
  height: 18px;
}
.index .loginPart .newDiv .newDivLeft input {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.index .loginPart .newDiv .newDivLeft p {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}
.index .loginPart .forgetPassword {
  display: block;
  text-align: right;
  width: 150px;
  /* width: 200px; */
  height: 15px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #158DD3;
  /* margin-left: 60%; */
  /* margin-top: 6%; */
  cursor: pointer;
}
/* <div class="newDiv">
          <div class="newDivLeft">
            <input type="checkbox">
            <span>记住密码</span>
          </div>
          <span class="forgetPassword" @click="forgetPasswordEvent()">忘记密码？</span>
        </div> */
.index .loginPart .loginBtn {
  width: 90%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
  background: #158DD3;
  margin: 0 auto;
  margin-top: 5%;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
}
.index #forget {
  width: 40%;
  cursor: default;
}
.index #forget:hover {
  color: #b5b4b4;
  border: 0;
}
.index .top .phone {
  display: block;
  width: 12%;
  height: 97%;
  position: absolute;
  right: 25%;
  top: 10%;
}
.index .top .p1 {
  width: 20%;
  height: 26px;
  line-height: 36px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  position: absolute;
  left: 22%;
  top: 19%;
}
.index .top .p2 {
  width: 20%;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  position: absolute;
  left: 22%;
  top: 40%;
}
/* <div class="top">
        <img src="../assets/topImg.png" alt="">
        <img src="../assets/phone.png" alt="">
        <p class="p1">电磁阀1.2版全新上线<br>推出多项功能</p>
        <p class="">用户通过电磁阀app可随时随地查询测试数据，<br> 获取更多更多实用信息</p>
    </div> */
.index .title {
  font-size: 18px;
  color: #676666;
  text-align: center;
  height: 40px;
  /* width: 100px; */
  /* line-height: 40px; */
  border-bottom: 4px solid #158DD3;
  margin: 0 auto;
  padding-bottom: 10px;
}
.index .componayIntro {
  width: 80%;
  margin: 0 auto;
  text-indent: 2em;
  text-align: left;
  font-size: 14px;
  /* color: rgb(0, 0, 0); */
  /* line-height: 40px; */
  margin-top: 30px;
  /* font-family: MicrosoftYaHei; */
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(77, 77, 77, 1);
  line-height: 40px;
  text-align: justify;
  text-indent: 2em;
  text-justify: inter-ideograph;
}
.index .aboutUs {
  display: block;
  width: 827px;
  height: 459px;
  margin: 0 auto;
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
  /* margin-bottom: 30px; */
  /* background-color: rgb(92, 114, 154); */
  margin-top: 58px;
  border: 18px solid #158DD3;
}
/* .index .aboutUs {
  width: 78%;
  height: 40%;
} */
/* #newMapDiv{
   width: 100%;
  height: 500px;
  padding: 10px;
  margin-top: -5%;
  margin-right: 10%;
  border: 18px solid rgb(137, 170, 229);
  box-sizing: border-box;
}
.index .aboutUs .aboutUsLeft{
  width: 100%;
  height: 100%;
  z-index:999;
} */
.index .aboutUs .aboutUsLeft {
  width: 100%;
  height: 459px;
  padding: 10px;
}
.index .aboutUs .aboutUsLeft {
  /* margin-top: -5%; */
  margin-right: 10%;
  border: 6px solid #fff;
  box-sizing: border-box;
}
.index .aboutUsRight {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .index .aboutUs .aboutUsLeft{
    width: 100px;
    height: 100px;
} */
.index .aboutUsRight li {
  width: 100%;
  text-align: left;
  /* color: #000; */
  font-size: 12px;
  line-height: 80px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  text-align: center;
}
.index .address {
  width: 80%;
  margin: 30px auto;
  font-size: 12px;
  /* margin-top: 2%; */
  color: gray;
  padding-bottom: 32px;
}
.index .onlyLef {
  position: relative;
  width: 55%;
}
.index .onlyRig {
  position: relative;
  width: 38%;
  background-color: rgba(255, 255, 255, 0.6) !important;
  margin-top: 8%;
  margin-right: 3%;
  padding: 30px 0;
}
.index .el-carousel__item--card {
  width: 100%;
  left: -25%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue